/**
 * ver 0.1
 * author jack
 */
import React from 'react'

class DefaultMobileLayer extends React.Component {
    render() {
        return (
            <div className="layerPop">
                <div className="layerCon">
                    <div className="Popcont">
                        {this.props.children}
                    </div>
                    <div className="popBtnWrap">
                        <button type="button" className="popnor" onClick={() => this.props.onClose()}>확인</button>
                    </div>
                    <button type="button" className="btn_layer_clse" onClick={() => this.props.onClose()}>
                        <i className="icon-close" />
                        <span className="ir">닫기</span>
                    </button>
                </div>
            </div>
        )
    }
}
export default DefaultMobileLayer



// WEBPACK FOOTER //
// ./src/common/container/layer/defaultMobileLayer.js